import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import history from '../src/utility/history';
import { AuthProvider } from './utility/auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
  <HistoryRouter history={history}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </HistoryRouter>,
  // // </BrowserRouter>
);
